import { formatDateString } from "@/utils/date";
import React, { useEffect, useState } from "react";
import { IEmailAIExtractedData } from "../../types/common";
import { FieldData } from "../tables/BaseTable";
import {
  FiltersFormData,
  ISearchFormData,
  TableSelector,
} from "./TableFiltersForm";

const useTableFilters = () => {
  const [filters, setFilters] = useState<Record<string, any> | null>(null);

  useEffect(()=>{
    console.log(filters)
  },[filters])

  // const getFilteredData = (data: FieldData[]) => {
  //   if (!filters) return data;

  //   return data?.filter((d) => {
  //     let some = true;
  //     for (let selector in filters) {
  //       if (!filters[selector as TableSelector]![0]) {
  //         continue;
  //       }

  //       switch (selector) {
  //         case "owners":
  //           {
  //             if (
  //               !d.owners
  //                 ?.map((o) => o.fullName)
  //                 .includes(filters["owners"]![0])
  //             ) {
  //               some = false;
  //               break;
  //             }
  //           }
  //           break;
  //         case "createdAt":
  //           {
  //             if (formatDateString(d.createdAt) !== filters["createdAt"]![0]) {
  //               some = false;
  //               break;
  //             }
  //           }
  //           break;
  //         case "ssn":
  //           {
  //             if (
  //               !d.owners?.find(
  //                 (o) =>
  //                   o.last4ssn?.toLowerCase() ===
  //                   filters["ssn"]![0].toLowerCase(),
  //               )
  //             ) {
  //               some = false;
  //               break;
  //             }
  //           }
  //           break;
  //         default: {
  //           if (
  //             filters[selector as TableSelector]![0] !==
  //             d[selector as keyof (typeof data)[0]]
  //           ) {
  //             some = false;
  //             break;
  //           }
  //         }
  //       }
  //     }
  //     return some;
  //   });
  // };

  return {
    filters,
    setFilters,
  };
};

export default useTableFilters;
